import type { CrmTranslate } from './crm-copy';

export function createCrmContactDetailsCopy(t: CrmTranslate) {
  return {
    contactView: {
      fallbacks: {
        empty: t('crm.contactView.fallbacks.empty'),
        contact: t('crm.contactView.fallbacks.contact'),
        profile: t('crm.contactView.fallbacks.profile'),
        unnamedContact: t('crm.contactView.fallbacks.unnamedContact'),
        unknownError: t('crm.contactView.fallbacks.unknownError'),
        yes: t('crm.contactView.fallbacks.yes'),
        no: t('crm.contactView.fallbacks.no'),
      },
      empty: {
        selectContactTitle: t('crm.contactView.empty.selectContactTitle'),
        selectContactDescription: t('crm.contactView.empty.selectContactDescription'),
        notFoundTitle: t('crm.contactView.empty.notFoundTitle'),
        notFoundDescription: t('crm.contactView.empty.notFoundDescription'),
        noRecentActivity: t('crm.contactView.empty.noRecentActivity'),
        noNotesYet: t('crm.contactView.empty.noNotesYet'),
        noFilesUploaded: t('crm.contactView.empty.noFilesUploaded'),
        noActivityHistory: t('crm.contactView.empty.noActivityHistory'),
      },
      actions: {
        backToContacts: t('crm.contactView.actions.backToContacts'),
        edit: t('crm.contactView.actions.edit'),
        delete: t('crm.contactView.actions.delete'),
        addNote: t('crm.contactView.actions.addNote'),
        uploadFiles: t('crm.contactView.actions.uploadFiles'),
        view: t('crm.contactView.actions.view'),
        downloadPdf: t('crm.contactView.actions.downloadPdf'),
        confirm: t('crm.contactView.actions.confirm'),
        cancel: t('crm.contactView.actions.cancel'),
      },
      confirmDelete: {
        title: t('crm.contactView.confirmDelete.title'),
        message: t('crm.contactView.confirmDelete.message'),
      },
      tabs: {
        overview: t('crm.contactView.tabs.overview'),
        notes: (count: number) =>
          t('crm.contactView.tabs.notes', {
            values: { count },
          }),
        files: (count: number) =>
          t('crm.contactView.tabs.files', {
            values: { count },
          }),
        activity: t('crm.contactView.tabs.activity'),
        inbox: t('crm.contactView.tabs.inbox'),
      },
      sections: {
        contactInformation: t('crm.contactView.sections.contactInformation'),
        professionalInformation: t('crm.contactView.sections.professionalInformation'),
        emailVerification: t('crm.contactView.sections.emailVerification'),
        locationInformation: t('crm.contactView.sections.locationInformation'),
        socialWeb: t('crm.contactView.sections.socialWeb'),
        audienceProfile: t('crm.contactView.sections.audienceProfile'),
        linkedInEnrichment: t('crm.contactView.sections.linkedInEnrichment'),
        marketingAttribution: t('crm.contactView.sections.marketingAttribution'),
        outreachTargeting: t('crm.contactView.sections.outreachTargeting'),
        recentActivity: t('crm.contactView.sections.recentActivity'),
      },
      labels: {
        name: t('crm.contactView.labels.name'),
        salutation: t('crm.contactView.labels.salutation'),
        middleName: t('crm.contactView.labels.middleName'),
        suffix: t('crm.contactView.labels.suffix'),
        email: t('crm.contactView.labels.email'),
        phone: t('crm.contactView.labels.phone'),
        mobilePhone: t('crm.contactView.labels.mobilePhone'),
        company: t('crm.contactView.labels.company'),
        jobTitle: t('crm.contactView.labels.jobTitle'),
        employmentRole: t('crm.contactView.labels.employmentRole'),
        seniority: t('crm.contactView.labels.seniority'),
        department: t('crm.contactView.labels.department'),
        leadStatus: t('crm.contactView.labels.leadStatus'),
        lifecycleStage: t('crm.contactView.labels.lifecycleStage'),
        leadScore: t('crm.contactView.labels.leadScore'),
        contactAccuracyGrade: t('crm.contactView.labels.contactAccuracyGrade'),
        emailVerificationStatus: t('crm.contactView.labels.emailVerificationStatus'),
        emailVerificationProvider: t('crm.contactView.labels.emailVerificationProvider'),
        emailVerifiedAt: t('crm.contactView.labels.emailVerifiedAt'),
        emailDomainMatch: t('crm.contactView.labels.emailDomainMatch'),
        enrichmentSource: t('crm.contactView.labels.enrichmentSource'),
        enrichmentBatchId: t('crm.contactView.labels.enrichmentBatchId'),
        sourceConfidence: t('crm.contactView.labels.sourceConfidence'),
        educationLevel: t('crm.contactView.labels.educationLevel'),
        externalId: t('crm.contactView.labels.externalId'),
        city: t('crm.contactView.labels.city'),
        stateRegion: t('crm.contactView.labels.stateRegion'),
        country: t('crm.contactView.labels.country'),
        postalCode: t('crm.contactView.labels.postalCode'),
        address: t('crm.contactView.labels.address'),
        website: t('crm.contactView.labels.website'),
        companyDomain: t('crm.contactView.labels.companyDomain'),
        companySize: t('crm.contactView.labels.companySize'),
        tags: t('crm.contactView.labels.tags'),
        created: t('crm.contactView.labels.created'),
        primaryPlatform: t('crm.contactView.labels.primaryPlatform'),
        primaryHandle: t('crm.contactView.labels.primaryHandle'),
        followerCount: t('crm.contactView.labels.followerCount'),
        followersUpdated: t('crm.contactView.labels.followersUpdated'),
        niche: t('crm.contactView.labels.niche'),
        primaryProfile: t('crm.contactView.labels.primaryProfile'),
        headline: t('crm.contactView.labels.headline'),
        timezone: t('crm.contactView.labels.timezone'),
        followers: t('crm.contactView.labels.followers'),
        connections: t('crm.contactView.labels.connections'),
        captured: t('crm.contactView.labels.captured'),
        about: t('crm.contactView.labels.about'),
        recentExperience: t('crm.contactView.labels.recentExperience'),
        leadSource: t('crm.contactView.labels.leadSource'),
        latestTrafficSource: t('crm.contactView.labels.latestTrafficSource'),
        originalTrafficSource: t('crm.contactView.labels.originalTrafficSource'),
        firstTouchCampaign: t('crm.contactView.labels.firstTouchCampaign'),
        lastTouchCampaign: t('crm.contactView.labels.lastTouchCampaign'),
        outreachMotions: t('crm.contactView.labels.outreachMotions'),
        outreachCampaigns: t('crm.contactView.labels.outreachCampaigns'),
        outreachAngles: t('crm.contactView.labels.outreachAngles'),
        outreachPersonas: t('crm.contactView.labels.outreachPersonas'),
        outreachReadiness: t('crm.contactView.labels.outreachReadiness'),
        outreachBlockReason: t('crm.contactView.labels.outreachBlockReason'),
        outreachEvidence: t('crm.contactView.labels.outreachEvidence'),
        outreachSourceUrl: t('crm.contactView.labels.outreachSourceUrl'),
        trafficSourceDate: t('crm.contactView.labels.trafficSourceDate'),
        contactOwner: t('crm.contactView.labels.contactOwner'),
        hubSpotTeam: t('crm.contactView.labels.hubSpotTeam'),
        externalProfile: t('crm.contactView.labels.externalProfile'),
      },
      links: {
        viewProfile: t('crm.contactView.links.viewProfile'),
        visitWebsite: t('crm.contactView.links.visitWebsite'),
        openCompany: t('crm.contactView.links.openCompany'),
      },
      activity: {
        loading: t('crm.contactView.activity.loading'),
        addedNote: t('crm.contactView.activity.addedNote'),
        movedTo: (stage: string | undefined) =>
          t('crm.contactView.activity.movedTo', {
            values: { stage },
          }),
        byUser: (user: string) =>
          t('crm.contactView.activity.byUser', {
            values: { user },
          }),
      },
      notes: {
        placeholder: t('crm.contactView.notes.placeholder'),
        loading: t('crm.contactView.notes.loading'),
        badge: t('crm.contactView.notes.badge'),
      },
      files: {
        loading: t('crm.contactView.files.loading'),
        sizeUnits: [
          t('crm.contactView.files.sizeUnits.bytes'),
          t('crm.contactView.files.sizeUnits.kb'),
          t('crm.contactView.files.sizeUnits.mb'),
          t('crm.contactView.files.sizeUnits.gb'),
        ],
        zeroBytes: t('crm.contactView.files.zeroBytes'),
        couldNotOpen: (error: string) =>
          t('crm.contactView.files.couldNotOpen', {
            values: { error },
          }),
        couldNotDownload: (error: string) =>
          t('crm.contactView.files.couldNotDownload', {
            values: { error },
          }),
        allowPopupsView: t('crm.contactView.files.allowPopupsView'),
        allowPopupsDownload: t('crm.contactView.files.allowPopupsDownload'),
      },
      inbox: {
        title: t('crm.contactView.inbox.title'),
        emptyDescription: t('crm.contactView.inbox.emptyDescription'),
      },
    },
    contactQuickView: {
      actions: {
        viewFullContact: t('crm.contactQuickView.actions.viewFullContact'),
        editContact: t('crm.contactQuickView.actions.editContact'),
        viewAllNotes: (count: number) =>
          t('crm.contactQuickView.actions.viewAllNotes', {
            values: { count },
          }),
        viewAllAttachments: (count: number) =>
          t('crm.contactQuickView.actions.viewAllAttachments', {
            values: { count },
          }),
      },
      sections: {
        professional: t('crm.contactQuickView.sections.professional'),
        location: t('crm.contactQuickView.sections.location'),
        additionalInfo: t('crm.contactQuickView.sections.additionalInfo'),
        recentNotes: (count: number) =>
          t('crm.contactQuickView.sections.recentNotes', {
            values: { count },
          }),
        attachments: (count: number) =>
          t('crm.contactQuickView.sections.attachments', {
            values: { count },
          }),
      },
      labels: {
        mobile: t('crm.contactQuickView.labels.mobile'),
        stage: t('crm.contactQuickView.labels.stage'),
        status: t('crm.contactQuickView.labels.status'),
        role: t('crm.contactQuickView.labels.role'),
        added: t('crm.contactQuickView.labels.added'),
      },
      notes: {
        placeholder: t('crm.contactQuickView.notes.placeholder'),
        empty: t('crm.contactQuickView.notes.empty'),
      },
      confirmDeleteNote: {
        title: t('crm.contactQuickView.confirmDeleteNote.title'),
        message: t('crm.contactQuickView.confirmDeleteNote.message'),
      },
      errors: {
        failedDeleteContact: t('crm.contactQuickView.errors.failedDeleteContact'),
        failedAddNote: t('crm.contactQuickView.errors.failedAddNote'),
        failedDeleteNote: t('crm.contactQuickView.errors.failedDeleteNote'),
      },
    },
    companyQuickView: {
      actions: {
        viewContacts: (count: number) =>
          t('crm.companyQuickView.actions.viewContacts', {
            values: { count },
          }),
        viewFullDetails: t('crm.companyQuickView.actions.viewFullDetails'),
        editCompany: t('crm.companyQuickView.actions.editCompany'),
      },
      sections: {
        companyDetails: t('crm.companyQuickView.sections.companyDetails'),
        description: t('crm.companyQuickView.sections.description'),
      },
      labels: {
        email: t('crm.companyQuickView.labels.email'),
        phone: t('crm.companyQuickView.labels.phone'),
        website: t('crm.companyQuickView.labels.website'),
        address: t('crm.companyQuickView.labels.address'),
        companySize: t('crm.companyQuickView.labels.companySize'),
        contacts: t('crm.companyQuickView.labels.contacts'),
        created: t('crm.companyQuickView.labels.created'),
      },
      counts: {
        contacts: (count: number) =>
          t('crm.companyQuickView.counts.contacts', {
            values: { count },
          }),
      },
      formatters: {
        companySize: (size: string) =>
          t('crm.companyQuickView.formatters.companySize', {
            values: { size },
          }),
      },
    },
  };
}
